import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import CanvasPage from './pages/CanvasPage';
import StoriesPage from './pages/StoriesPage';
import JournalPage from './pages/JournalPage';
import ProfilePage from './pages/ProfilePage';
import LandingPage from './pages/index'; // Import the LandingPage component

const App = () => {
  return (
    <Router>
      <div style={{minHeight: '100vh', backgroundColor: '#F9FAFB'}}>
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} /> {/* Use LandingPage for the root path */}
          <Route path="/canvas" element={<CanvasPage />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;